import { render, staticRenderFns } from "./default.vue?vue&type=template&id=f53c6736"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=f53c6736&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavBar: require('/builds/marketing/abstracta.academy-website/components/NavBar.vue').default,PromoModal: require('/builds/marketing/abstracta.academy-website/components/PromoModal.vue').default})
